import * as Scrivito from "scrivito";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("Locals", {
  title: "Locals",
  attributes: {
    title: {
      title: "Title",
    },
    ...metadataEditingConfigAttributes,
  },
  hideInSelectionDialogs: true,
  initialContent: {
    localsAE: "{}",
    localsFJ: "{}",
    localsKO: "{}",
    localsPT: "{}",
    localsUZ: "{}",
    ...metadataInitialContent,
  },
});
